// Tout le contenu textuel du site Lucarne Ops (issu de la présentation)
import {
  Activity, Building2, Cpu, BarChart3, FolderKanban,
  Users, Zap, TrendingUp, Stethoscope, GraduationCap, Factory, Briefcase,
} from "lucide-react";

export const IDENTITY = {
  brand: "Lucarne Ops",
  name: "Romain Souffre",
  role: "Directeur des Opérations & de la Performance",
  subRole: "Transformation · Organisation · Excellence · Transitions",
  tagline: "Voir juste, agir vite, délivrer.",
  email: "contact@lucarneops.fr",
  linkedin: "https://linkedin.com/in/romainsouffre",
  linkedinLabel: "linkedin.com/in/romainsouffre",
  siren: "511 528 259",
  domain: "www.lucarneops.fr",
};

export const METRICS = [
  { value: "+25 ans", label: "d'expérience terrain" },
  { value: "🚀🚀🚀", label: "Croissance organique, volumétrique et intensive" },
  { value: "170", label: "collaborateurs pilotés" },
  { value: "400 M€", label: "de CA supervisé" },
];

export const VALUE_PROP = {
  intro: "Transformation en environnement régulé — avec méthode, rapidité, innovation et résultats mesurables.",
  points: [
    {
      icon: Zap,
      title: "Opérationnel, dès aujourd'hui",
      text: "Je dirige, je décide, je produis des résultats concrets sur le terrain.",
    },
    {
      icon: Activity,
      title: "Double culture Industrie & Santé",
      text: "PSA, ArcelorMittal, établissements hospitaliers & sanitaires, Éducation : une amplitude singulière, un profil atypique.",
    },
    {
      icon: TrendingUp,
      title: "Des résultats chiffrés",
      text: "+30% d'activité, 95% d'ouverture de blocs, 92% de taux de réponse, coûts variables maîtrisés, climat social transformé.",
    },
  ],
};

export const OFFERS = [
  {
    num: "01",
    icon: Users,
    title: "Management d'équipe & accompagnement au changement",
    desc: "Direction d'équipes directes et indirectes (100 à 170 personnes) · management par objectifs · développement des compétences · dialogue social · conduite du changement · climat social.",
    proofs: [
      "170 collaborateurs pilotés en COMEX (Rothschild)",
      "Conduite du changement sur CSP multi-sites (PSA · 19 usines)",
      "Dialogue social & PSE menés sur 3 ans (ArcelorMittal)",
    ],
  },
  {
    num: "02",
    icon: Building2,
    title: "Transformation",
    desc: "Refonte des modèles d'organisation · centres de service (CSP / BPO) & process · digitalisation des parcours (patients, clients, salariés) · direction de projets SI / AMOA · mise en production dans les délais.",
    proofs: [
      "CSP paie créé de A à Z : 100 000 bulletins/mois (PSA · 19 usines)",
      "Digitalisation des parcours & portail patient (GHPSJ · Doctolib)",
      "Migration SAP RH France livrée dans les délais (ArcelorMittal)",
    ],
  },
  {
    num: "03",
    icon: BarChart3,
    title: "Excellence opérationnelle",
    desc: "Audit rapide des leviers · pilotage KPI & tableaux de bord · maîtrise des coûts · adéquation activité / effectifs (ETP) · prévisions d'activité · efficience data-driven.",
    proofs: [
      "+30% d'activité en 2 ans (Rothschild)",
      "Ouverture des blocs 95%+ · occupation des lits 90% (GHPSJ)",
      "100 cliniques auditées & plan de performance (Clariane)",
    ],
  },
];

export const SECTORS = [
  { icon: Stethoscope, name: "Santé", detail: "GHPSJ · Rothschild · Clariane" },
  { icon: GraduationCap, name: "Éducation", detail: "Omnes Education" },
  { icon: Factory, name: "Industrie", detail: "ArcelorMittal · PSA" },
  { icon: Briefcase, name: "Services", detail: "Centres de service · BPO" },
];

export const PREFERRED = [
  {
    icon: Users,
    title: "Organisation de l'efficience RH opérationnelle",
    text: "Refonte des modèles de service RH, centres de services partagés (CSP), process et productivité : structurer une fonction RH performante et mesurable.",
  },
  {
    icon: Stethoscope,
    title: "Pilotage des établissements de santé",
    text: "Blocs, lits, flux, parcours patients, contrôle de gestion et valorisation : piloter la performance opérationnelle et économique des établissements.",
  },
];

export const TIMELINE = [
  {
    period: "2025 — 2026",
    org: "Clariane · Omnes Education",
    sector: "Santé · Éducation",
    role: "Missions de transition",
    detail: "Dir. Performance (100 cliniques · 600 M€ · 6 000 salariés) · Dir. CSP (40 000 étudiants · 400 M€).",
  },
  {
    period: "2022 — 2025",
    org: "Fondation Adolphe de Rothschild",
    sector: "Santé",
    role: "Directeur Opérations & Performance — COMEX",
    detail: "170 collaborateurs · CA 180 M€ · 1 600 salariés · +30% d'activité.",
  },
  {
    period: "2013 — 2021",
    org: "Groupe Hospitalier Paris Saint-Joseph",
    sector: "Santé",
    role: "Dir. Parcours Patients & Contrôle de Gestion",
    detail: "300 000 RDV/an · 100 collaborateurs · +10%/an.",
  },
  {
    period: "2011 — 2013",
    org: "Groupe PSA",
    sector: "Automobile",
    role: "Directeur Projet Transformation RH",
    detail: "CSP paie créé de A à Z · 19 usines · 100 000 bulletins/mois.",
  },
  {
    period: "2000 — 2011",
    org: "ArcelorMittal France",
    sector: "Métallurgie",
    role: "Dir. CSP RH · Dir. Projet SAP RH France",
    detail: "18 000 bulletins · 45 clients · PSE 3 ans · 6 usines.",
  },
];

export const SAVOIR_FAIRE = [
  "Pilotage efficience & performance",
  "Optimisation des process",
  "Dialogue social & négociation",
  "Management par objectif",
  "Conduite du changement",
  "Lean management",
  "Planification des ressources",
  "Contrôle de gestion social",
  "Conception d'outils d'analyse",
];

export const SAVOIR_ETRE = [
  "Esprit d'équipe & collectif",
  "Écoute active",
  "Empathie",
  "Autonomie & initiative",
  "Résilience sous pression",
  "Créativité opérationnelle",
  "Persévérance",
  "Sens des responsabilités",
  "Goût du défi",
];

export const DIFFERENTIATORS = [
  {
    num: "01",
    title: "Pragmatisme & décision",
    text: "Je vois vite ce qui compte. Je décide. Je n'attends pas le consensus pour agir quand l'urgence l'impose. Diagnostic juste avant d'agir.",
    tags: ["Pragmatisme", "Intuition", "Sens logique", "Adaptabilité"],
  },
  {
    num: "02",
    title: "Endurance & robustesse",
    text: "25 ans dans des environnements sous pression budgétaire, humaine et organisationnelle. Je tiens dans la durée, sans perdre le cap ni la qualité des décisions.",
    tags: ["Endurance", "Résilience", "Robustesse", "Courage"],
  },
  {
    num: "03",
    title: "Collectif & leadership humain",
    text: "J'anime des équipes directes et indirectes de 100 à 170 personnes. J'écoute avant de transformer. L'engagement n'est pas une décoration, c'est un levier opérationnel.",
    tags: ["Esprit d'équipe", "Empathie", "Altruisme", "Engagement"],
  },
  {
    num: "04",
    title: "Créativité & ouverture",
    text: "Je ne reproduis pas des modèles : je les adapte. La créativité est une obligation opérationnelle, elle nourrit les solutions que d'autres n'ont pas vues. Je m'appuie sur l'innovation digitale, un levier d'efficience et de satisfaction : par ma présence dans les écosystèmes innovants (Agoranov, Paris Santé, Wilco), je détecte les partenaires de rupture.",
    tags: ["Créativité", "Ouverture", "Innovation", "Autonomie"],
  },
];

export const MODALITES = [
  { label: "Disponibilité", value: "Rapide et adaptable" },
  { label: "Durée type", value: "Missions de 3 à 12 mois" },
  { label: "Mobilité", value: "Nationale et internationale, courte durée · télétravail partiel" },
  { label: "Nature", value: "Transition · Transformation · Audit / Conseil" },
  { label: "Contractualisation", value: "Ouverte : contrat de travail, prestations de management de transition, prestations d'audit / conseil" },
];

export const TRUST = [
  { name: "ArcelorMittal" }, { name: "Groupe PSA" },
  { name: "Groupe Hospitalier Paris St Joseph" },
  { name: "Hôpital Fondation Adolphe de Rothschild" },
  { name: "Clariane" }, { name: "Omnes Education" },
  { name: "Croix-Rouge française" },
];

export const NAV = [
  { to: "/", label: "Accueil" },
  { to: "/offres", label: "Offres" },
  { to: "/parcours", label: "Parcours" },
];

export const HERO_BG = "https://static.prod-images.emergentagent.com/jobs/58fe6db6-ab92-432b-9fb4-2cd003e9b134/images/ae1f9eb165acd06b4cac66f6842d4eafee1d8284c7e587b73eb73a6f443d5d44.png";
